import { createGraphqlClient } from "./hooks/utils";

const graphqlClient = createGraphqlClient();
export default graphqlClient;
